TrustedFilter.$inject = ['$sce'];
export function TrustedFilter($sce) {
    'ngInject';
    return (url) => typeof url === 'string'
        ? $sce.trustAsResourceUrl(url)
        : '';
}
